<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { createEventDispatcher } from "svelte";
    import { fade } from "svelte/transition";
    const dispatch = createEventDispatcher();
    let searchText = "";
    let isSearchBarEnabled = false;
    let isButtonEnabled = false;
    let timeoutId;
    function clearSearch() {
        searchText = "";
    }

    function search() {
        dispatch("search", searchText);
    }

    function toggleSearch() {
        isSearchBarEnabled = !isSearchBarEnabled;
        dispatch("toggleSearch", isSearchBarEnabled);

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        if (isSearchBarEnabled) {
            timeoutId = setTimeout(() => {
                isButtonEnabled = true;
            }, 150);
        } else {
            isButtonEnabled = false;
        }
    }




</script>

<div class="" id="map_search_input">
    <div
        class="btn bg-transparent"
        id="map_search"
        on:click={() => toggleSearch()}
        on:keypress={(e) =>{if (e.key === "Enter") {toggleSearch()}}
        }
    >
        <svg
            class="svg-inline--fa fa-magnifying-glass"
            id="map_search_icon"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="magnifying-glass"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            data-fa-i2svg=""
            ><path
                fill="currentColor"
                d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"
            ></path></svg
        >
    </div>
    {#if isButtonEnabled}
        <input
            class="map_search_field"
            type="text"
            id="map_search_field"
            placeholder="Type and click Enter"
            bind:value={searchText}
            on:keydown={(event) => event.key === 'Enter' && search()}
            in:fade
        /><button
            id="del_map_search"
            class="btn bg-transparent btn-clear ml-1 p-0 mr-0"
            style="box-shadow: none;"
            in:fade
            on:click={() => clearSearch()}
            ><svg
                class="svg-inline--fa fa-xmark p-0 m-1"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="xmark"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                data-fa-i2svg=""
                ><path
                    fill="currentColor"
                    d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
                ></path></svg
            ></button
        >
    {/if}
</div>
